import React, {useState, useEffect} from "react";
import {Button, Modal} from "@mui/material";
import Box from "@mui/material/Box";
import {ThemeProvider} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Theme } from "../../Components/styles/styles";
import dayjs from "dayjs";
import './DeleteClientFromLeadBox.css'


const DeleteClientFromLeadBox = (
    {
        deleteClientModal,
        handleCloseDeleteClientModal,
        activeLeadDetails,
        confirmDeleteClient,
        rejectDeleteClient,
    }
) => {

    if (activeLeadDetails && 'Zapomniano' !== activeLeadDetails.name) {

        return (
            <Modal
                className="delete-client-from-lead-box"
                open={deleteClientModal}
                onClose={handleCloseDeleteClientModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal">
                    <Box className="view">
                        <ThemeProvider theme={Theme}>
                            <Box>
                                <Typography
                                    variant="h4"
                                    lineHeight={1.38}
                                    letterSpacing={0.23}
                                    fontSize="26px"
                                >
                                    Dane kontaktu do skasowania
                                </Typography>
                            </Box>

                            <Box>
                                <Typography
                                    variant="bodyMediumRegural"
                                    lineHeight={1.33}
                                    letterSpacing={0.16}
                                    fontSize="18px"
                                >
                                    Szczegółowe informacje o kontakcie:
                                </Typography>
                            </Box>
                            <Box className="dialog">
                                <Box className="data-box">
                                    <Box className="row">
                                        <Box className="label">
                                            Nazwisko:
                                        </Box>
                                        <Box className="value">
                                            {activeLeadDetails.name}
                                        </Box>
                                    </Box>
                                    <Box className="row">
                                        <Box className="label">
                                            Adres:
                                        </Box>
                                        <Box className="value">
                                            {activeLeadDetails.address}
                                        </Box>
                                    </Box>
                                    <Box className="row">
                                        <Box className="label">
                                            Numer telefonu:
                                        </Box>
                                        <Box className="value">
                                            {activeLeadDetails.phone}
                                        </Box>
                                    </Box>
                                    <Box className="row">
                                        <Box className="label">
                                            Poczta elektroniczna:
                                        </Box>
                                        <Box className="value">
                                            {activeLeadDetails.mail}
                                        </Box>
                                    </Box>
                                    <Box className="row">
                                        <Box className="label">
                                            Data dodania:
                                        </Box>
                                        <Box className="value">
                                            {dayjs(activeLeadDetails.createdDate).format('YYYY-MM-DD HH:mm')}
                                        </Box>
                                    </Box>

                                </Box>

                                <Box className="buttons-box">
                                    <Button sx={Theme.RedButton}
                                            onClick={() => {
                                                handleCloseDeleteClientModal();
                                                rejectDeleteClient();
                                            }}
                                    >
                                        Anuluj
                                    </Button>

                                    <Button sx={Theme.BlueButton}
                                            onClick={() => {
                                                handleCloseDeleteClientModal();
                                                confirmDeleteClient();
                                            }}
                                    >
                                        Usuń dane
                                    </Button>
                                </Box>
                            </Box>
                        </ThemeProvider>
                    </Box>
                </Box>

            </Modal>
        )
    } else {
        return (
            <Modal
                className="delete-client-from-lead-box"
                open={deleteClientModal}
                onClose={handleCloseDeleteClientModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal">
                    <Box className="view">
                        <ThemeProvider theme={Theme}>
                            <Box>
                                <Typography
                                    variant="h4"
                                    lineHeight={1.38}
                                    letterSpacing={0.23}
                                    fontSize="26px"
                                >
                                    Osoba została usunięta z bazy danych.
                                </Typography>
                            </Box>

                            <Box>
                                <Typography
                                    variant="bodyMediumRegural"
                                    lineHeight={1.33}
                                    letterSpacing={0.16}
                                    fontSize="18px"
                                >
                                    Dane osoby tworzącej kontakt zostały "zapomniane" na jej żądanie.
                                </Typography>
                            </Box>
                            <Box className="dialog">

                                <Box className="data-box">

                                </Box>

                                <Box className="buttons-box">
                                    <Button sx={Theme.GreenButton}
                                            onClick={() => {
                                                handleCloseDeleteClientModal();
                                                rejectDeleteClient();
                                            }}
                                    >
                                        Zamknij.
                                    </Button>

                                </Box>
                            </Box>
                        </ThemeProvider>
                    </Box>
                </Box>

            </Modal>
        )

    }


}


export default DeleteClientFromLeadBox;